const baseurl =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=17.385044&lng=78.486671&sortBy=RELEVANCE&pageType=SEE_ALL&page_type=DESKTOP_SEE_ALL_LISTING";
// const page_type = "&page_type=DESKTOP_WEB_LISTING";
// const offset = "&offset=31";
// const sortby = "&sortBy=RELEVANCE";
// const pagetype = "&pageType=SEE_ALL";
export { baseurl };
const Url =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=17.385044&lng=78.486671&sortBy=RELEVANCE&page_type=DESKTOP_WEB_LISTING";
export const restUrl =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=17.385044&lng=78.486671&submitAction=ENTER";
export const imgurl =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";
export const SearchUrl =
  "https://www.swiggy.com/dapi/restaurants/search/suggest?lat=17.385044&lng=78.486671&trackingId=undefined";
export const SortUrl =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=17.385044&lng=78.486671&page_type=DESKTOP_WEB_LISTING";
export default Url;
